import { defineComponent as _defineComponent } from 'vue'
import AppButton from "@/components/AppButton.vue";
import { computed, ref, onMounted, onUnmounted } from "vue";
import { useCanvases } from "../lib/canvases";
import { clamp } from "../lib/clamp";
import { useDownload } from "../lib/download";
import { useDraggable, DraggedState } from "../lib/draggable";
import { ImageTransform } from "../types";
import ResizeImageCanvas from "./ResizeImageCanvas.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResizeFocalPoint',
  props: {
    transform: null,
    image: null
  },
  emits: ["update-transform"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "update-transform", transform: Partial<ImageTransform>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  transform: ImageTransform;
  image?: HTMLImageElement;
}





const { downloadAll } = useCanvases();
const { startDownload, downloading } = useDownload();

const onDragMove = ({ currentX, currentY }: DraggedState): void => {
  if (previewElement.value) {
    const { height, width, top, left } = previewElement.value.getBoundingClientRect();

    const x = currentX;
    const y = currentY;

    const focusX = clamp(0, (x - left) / width, 1);
    const focusY = clamp(0, (y - top) / height, 1);

    emits("update-transform", {
      focusX,
      focusY
    });
  }
};

const { dragStart } = useDraggable({
  onDragMove
});

const fixed = ref(false);
const previewElement = ref<HTMLElement>();

const io = new IntersectionObserver(([entry]) => {
  const { bottom = 0 } = entry?.target.getBoundingClientRect();
  const scrollTop = window.scrollY;

  const isBelow = scrollTop > bottom;

  fixed.value = isBelow && !entry.isIntersecting;
}, {});

const rootElement = ref<HTMLElement>();

onMounted(() => {
  if (rootElement.value?.parentElement) {
    io.observe(rootElement.value.parentElement);
  }
});

onUnmounted(() => {
  io.disconnect();
});

const handleStyles = computed(() => {
  return {
    left: props.transform.focusX * 100 + "%",
    top: props.transform.focusY * 100 + "%"
  };
});

return { __sfc: true,emits, props, downloadAll, startDownload, downloading, onDragMove, dragStart, fixed, previewElement, io, rootElement, handleStyles, AppButton, ResizeImageCanvas }
}

})